import { takeLatest, put, call, delay } from 'redux-saga/effects';
import { SUBMIT_CONTACT_FORM } from '../../constants/ActionTypes';
import { submitContactFormSuccess, submitContactFormFailure } from '../actions/ContactActions';
import { toast } from 'react-toastify';
import api from '../../util/Api';

// Worker saga for handling contact form submission
function* handleContactFormSubmission(action) {
  try {
    const formData = new FormData();
    const hubspotData = {
      firstname: action.payload.firstName,
      lastname: action.payload.lastName,
      state: action.payload.state,
      zip: action.payload.zipCode,
      phone: action.payload.phoneNumber,
      email: action.payload.email,
      affiliated_with_us_military: action.payload.militaryAffiliation,
      best_time_to_reach: action.payload.bestTimeToReach,
      course_type: action.payload.courseType,
      lead_type: "Contact"
    };

    formData.append("sentFormData", JSON.stringify(hubspotData));

    // Make API call using axios through the API utility with multipart/form-data header
    const response = yield call(api.post, '/api/ws_hubspot_contact', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    // Check if the response contains data
    if (!response || !response.data) {
      throw new Error('Invalid response from server');
    }

    // Dispatch success action with response
    yield put(submitContactFormSuccess(response.data));
    
    // Navigate to success page
    window.location.href = '/contactsuccess';

  } catch (error) {
    console.error('Contact form submission error:', error);

    // Determine the error message to display
    const errorMessage = error.response?.data?.response?.message || 
                        error.response?.data?.message ||
                        error.message || 
                        'An error occurred while submitting your contact information. Please try again.';

    // Dispatch failure action with error
    yield put(submitContactFormFailure(errorMessage));

    // Show error toast
    toast.error(errorMessage);
  }
}

// Root saga for contact module
export default function* contactSaga() {
  yield takeLatest(SUBMIT_CONTACT_FORM, handleContactFormSubmission);
}